import axiosInstance from '../utils/axiosInstance';
import { UpdatePaybackPlanPayload, UpdatePaybackPlanResponse } from './types';

export const updatePaybackPlan = async (payload: UpdatePaybackPlanPayload) => {
  const response = await axiosInstance.post<UpdatePaybackPlanResponse>('/payback-plan', payload);

  return response.data;
};
